export const ZONES_LIST = "ZONES_LIST";
export const ZONES_CREATE = "ZONES_CREATE";
export const ZONES_UPDATE = "ZONES_UPDATE";
export const ZONES_DELETE = "ZONES_DELETE";
export const ZONES_SHOW = "ZONES_SHOW";
